var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import styled, { css } from 'styled-components';
import { DefaultSkin } from '../../types/Skin';
var LegendBase = function (props) {
    // Pass skin prop to children:
    var childrenWithProps = React.Children.map(props.children, function (child) {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, { skin: props.skin });
        }
        return child;
    });
    return (React.createElement("div", { className: props.className }, childrenWithProps));
};
var LegendStyled = styled(LegendBase).attrs(function (p) {
    var _a;
    return ({
        skin: (_a = p.skin) !== null && _a !== void 0 ? _a : DefaultSkin
    });
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  /* Position */\n  position: absolute;\n  z-index: 100;\n  ", "\n  ", "\n  ", "\n  ", "\n\n  /* Content positioning */\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  gap: 12px;\n  pointer-events: none;\n\n  /* Appearance */\n  padding: 6px 12px 6px 12px;\n  box-shadow: 2px 2px 2px rgb(0,0,0,0.5);\n  border: solid 1px ", ";\n  border-radius: ", "px;\n  background: ", ";\n\n  /* Display legend entries vertically on small screens: */\n  @media (max-width: 700px) {\n    flex-direction: column;\n  }\n"], ["\n  /* Position */\n  position: absolute;\n  z-index: 100;\n  ", "\n  ", "\n  ", "\n  ", "\n\n  /* Content positioning */\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  gap: 12px;\n  pointer-events: none;\n\n  /* Appearance */\n  padding: 6px 12px 6px 12px;\n  box-shadow: 2px 2px 2px rgb(0,0,0,0.5);\n  border: solid 1px ", ";\n  border-radius: ", "px;\n  background: ", ";\n\n  /* Display legend entries vertically on small screens: */\n  @media (max-width: 700px) {\n    flex-direction: column;\n  }\n"
    /**
     * A box with LegendBox entries.
     */
])), function (p) { return p.x >= 0 && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["left:   ", "px; margin-right: 32px;"], ["left:   ", "px; margin-right: 32px;"])), p.x); }, function (p) { return p.x < 0 && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["right:  ", "px; margin-left: 32px;"], ["right:  ", "px; margin-left: 32px;"])), -p.x); }, function (p) { return p.y >= 0 && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["top:    ", "px;"], ["top:    ", "px;"])), p.y); }, function (p) { return p.y < 0 && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["bottom: ", "px;"], ["bottom: ", "px;"])), -p.y); }, function (p) { return p.skin.border; }, function (p) { return p.skin.radius; }, function (p) { return p.skin.fill; });
/**
 * A box with LegendBox entries.
 */
var Legend = function (props) { return React.createElement(LegendStyled, __assign({}, props)); };
export { Legend };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
